'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $('[data-copy-menu]', this).each(function () {
        var dcm = $(this);
        dcm.closest(".modal").on("show.bs.modal", function () {
            $(dcm.attr("data-copy-menu")).val("").trigger('change.select2');
            $(dcm.attr('data-copy-result')).html("");
        });
        dcm.off('click').on('click', function () {
            var itemId = dcm.attr('data-copy-item-id');
            var parentId = $(dcm.attr("data-copy-menu")).val();

            if (!parentId) {
                $(dcm.attr('data-copy-result')).html('<i class="fa fa-exclamation-triangle red" aria-hidden="true"></i> ' + resx.App.ChooseMenuItem);
                return;
            }
            menuService.copyItem(itemId, parentId).done(function () {
                _notify2.default.success(resx.Common.UpdateCopySuccess);
                $(".dataTable").DataTable().ajax.reload(null, false);
                $(dcm.attr("data-modal-close")).trigger("click");
            }).fail(function () {
                _message2.default.error(resx.Common.UpdateCopyFail);
            });
        });
    });
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Common", "App");
var $ = require("jquery");
var menuService = abp.services.api.menu;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/menuItemCopy.js
// module id = 441
// module chunks = 0